// extracted by mini-css-extract-plugin
module.exports = {"Feedback":"feedback_Feedback__cTX5G","Feedback__text":"feedback_Feedback__text__5mJx2","Feedback__rating":"feedback_Feedback__rating___mxve"};